import React, { useEffect, useState, useMemo } from "react";
import {
  Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, 
  Label, Input, Form, Badge, Spinner, Button, UncontrolledTooltip,
  Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

const KullaniciListesi = () => {
  document.title = "Kullanıcı Listesi | LojGo Admin";

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Modal State'leri
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  
  const [selectedUser, setSelectedUser] = useState(null);
  const [detailedUser, setDetailedUser] = useState(null);
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3;

  useEffect(() => {
    if (isAdmin) fetchUsers();
  }, [isAdmin]);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await fetch("https://hiflowapi.stechomeyazilim.info/Users?$expand=Users_Type&$orderby=ID desc");
      const result = await response.json();
      setUsers(result.value || []);
    } catch (error) {
      toast.error("Kullanıcılar yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  // --- PROFİL DETAYLARINI ÇEK (OData $expand ile) ---
  const handleViewProfile = async (user) => {
    setViewModal(true);
    setIsDetailsLoading(true);
    setActiveTab("1");
    try {
      const response = await fetch(
        `https://hiflowapi.stechomeyazilim.info/Users?$filter=ID eq ${user.ID}&$expand=Users_Address,Users_Driving_License,Users_BankAccount,Users_Document,Users_Company($expand=Users_Invoince)`
      );
      const result = await response.json();
      if (result.value && result.value.length > 0) {
        setDetailedUser(result.value[0]);
      }
    } catch (error) {
      toast.error("Profil detayları yüklenemedi.");
    } finally {
      setIsDetailsLoading(false);
    }
  };

  const columns = useMemo(() => [
    { header: "ID", accessorKey: "ID", cell: (c) => <strong>#{c.getValue()}</strong> },
    {
      header: "Ad Soyad",
      accessorKey: "Users_NameSurname",
      cell: (c) => (
        <div className="d-flex align-items-center">
          <div className="avatar-xs me-2">
            <span className="avatar-title rounded-circle bg-primary-subtle text-primary">{c.getValue()?.charAt(0)}</span>
          </div>
          {c.getValue()}
        </div>
      ),
    },
    { header: "E-posta", accessorKey: "Users_Email" },
    { header: "Rol", accessorKey: "Users_Type.Users_Type_Title", cell: (c) => <Badge color="info" pill>{c.getValue()}</Badge> },
    {
      header: "Durum",
      accessorKey: "IsActive",
      cell: (c) => <Badge color={c.getValue() ? "success" : "danger"}>{c.getValue() ? "Aktif" : "Pasif"}</Badge>
    },
    {
      header: "Aksiyon",
      cell: (cellProps) => {
        const user = cellProps.row.original;
        return (
          <div className="d-flex gap-3">
            <Button color="link" className="p-0 text-success" onClick={() => { setSelectedUser(user); setEditModal(true); }}>
              <i className="mdi mdi-pencil font-size-18" id={`edit-${user.ID}`} />
            </Button>
            <Button color="link" className="p-0 text-primary" onClick={() => handleViewProfile(user)}>
              <i className="mdi mdi-eye font-size-18" id={`view-${user.ID}`} />
            </Button>
            <UncontrolledTooltip target={`edit-${user.ID}`}>Düzenle</UncontrolledTooltip>
            <UncontrolledTooltip target={`view-${user.ID}`}>Profili Gör</UncontrolledTooltip>
          </div>
        );
      }
    }
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcı Listesi" />
          <Card>
            <CardBody>
              {isLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : (
             <TableContainer
  columns={columns}
  data={users || []}
  isGlobalFilter={true}
  isPagination={true}
  // Sayfa başı kayıt miktarını veri sayısından büyükse veri sayısına eşitliyoruz
  customPageSize={users.length < 10 ? users.length : 10} 
  SearchPlaceholder="Kullanıcı ara..."
  // GÖRSEL BOZUKLUĞU DÜZELTEN SINIFLAR:
  tableClass="align-middle table-nowrap table-hover"
  theadClass="table-light"
  paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
  pagination="pagination pagination-rounded justify-content-end mb-2"
/>
              )}
            </CardBody>
          </Card>
        </Container>

        {/* --- MODAL: PROFİL GÖR (SALT OKUNUR) --- */}
        <Modal isOpen={viewModal} toggle={() => setViewModal(false)} centered size="xl">
          <ModalHeader toggle={() => setViewModal(false)}>
            <i className="bx bx-user-circle me-2"></i> Kullanıcı Profili Detayı
          </ModalHeader>
          <ModalBody className="bg-light-subtle">
            {isDetailsLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : detailedUser && (
              <>
                <Nav tabs className="nav-tabs-custom nav-justified mb-3 bg-white">
                  <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => setActiveTab("1")} style={{cursor:'pointer'}}>Genel</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => setActiveTab("2")} style={{cursor:'pointer'}}>Ehliyet</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => setActiveTab("3")} style={{cursor:'pointer'}}>Şirket & Banka</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeTab === "4" })} onClick={() => setActiveTab("4")} style={{cursor:'pointer'}}>Belgeler</NavLink></NavItem>
                </Nav>

                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Card><CardBody>
                      <Row>
                        <Col md={4} className="border-end">
                            <Label className="text-muted mb-0">Ad Soyad</Label><p className="fw-bold">{detailedUser.Users_NameSurname}</p>
                            <Label className="text-muted mb-0">E-posta</Label><p className="fw-bold">{detailedUser.Users_Email}</p>
                            <Label className="text-muted mb-0">Telefon</Label><p className="fw-bold">{detailedUser.Users_PhoneNumber}</p>
                        </Col>
                        <Col md={8}>
                            <Label className="text-muted mb-0">Adres</Label>
                            <p>{detailedUser.Users_Address?.[0]?.Users_Address_AdressText || "Bilgi Yok"}</p>
                            <p>{detailedUser.Users_Address?.[0]?.Users_Address_City} / {detailedUser.Users_Address?.[0]?.Users_Address_Dist}</p>
                        </Col>
                      </Row>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="2">
                    <Card><CardBody>
                      <Row>
                        <Col md={6}><Label className="text-muted mb-0">Ehliyet Sınıfı</Label><p className="fw-bold">{detailedUser.Users_Driving_License?.[0]?.Driving_License_Class || "---"}</p></Col>
                        <Col md={6}><Label className="text-muted mb-0">Ehliyet Numarası</Label><p className="fw-bold">{detailedUser.Users_Driving_License?.[0]?.Driving_License_Number || "---"}</p></Col>
                      </Row>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="3">
                    <Card><CardBody>
                      <h6 className="text-primary border-bottom pb-2">Şirket Bilgileri</h6>
                      <p><strong>Firma:</strong> {detailedUser.Users_Company?.[0]?.Users_Company_Name || "Kayıtlı Şirket Yok"}</p>
                      <p><strong>Vergi No:</strong> {detailedUser.Users_Company?.[0]?.Users_Invoince?.[0]?.KdvNumber || "---"}</p>
                      <h6 className="text-primary border-bottom pb-2 mt-4">Banka Bilgileri</h6>
                      <p><strong>IBAN:</strong> {detailedUser.Users_BankAccount?.[0]?.Users_BankAccount_Iban || "---"}</p>
                      <p><strong>Banka:</strong> {detailedUser.Users_BankAccount?.[0]?.Users_BankAccount_BankName || "---"}</p>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="4">
                    <Row>
                        {[
                            { n: "Kimlik", u: detailedUser.Users_Document?.[0]?.Identity_Url },
                            { n: "Ehliyet", u: detailedUser.Users_Document?.[0]?.License_Url },
                            { n: "Sabıka Kaydı", u: detailedUser.Users_Document?.[0]?.Criminalrecord_Url },
                            { n: "Vergi Levhası", u: detailedUser.Users_Document?.[0]?.Taxplate_Url }
                        ].map((doc, i) => (
                            <Col md={3} key={i}>
                                <Card className="text-center border shadow-none">
                                    <CardBody>
                                        <i className="mdi mdi-file-pdf-outline display-4 text-danger"></i>
                                        <p className="mt-2 fw-medium">{doc.n}</p>
                                        {doc.u ? <a href={doc.u} target="_blank" rel="noreferrer" className="btn btn-sm btn-soft-primary w-100">Görüntüle</a> : <Badge color="light" className="w-100">Yüklenmemiş</Badge>}
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                  </TabPane>
                </TabContent>
              </>
            )}
          </ModalBody>
        </Modal>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default KullaniciListesi;